export default class {
	constructor() {
		return this;
	}

	getDomain() {
		const a = location.hostname.replace(/^.*(\.)([^\.]+\.[^\.]+)$/, '$2');
		return a !== 'localhost' ? a : '';
	}

	set(name, value, days, domain) {
		let expires = '';
		if (days) {
			const d = new Date();
			d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + d.toGMTString();
		}
		document.cookie = name + '=' + value + expires + '; path=/' + (typeof domain !== 'undefined' ? '; domain=' + domain.replace(/^\./, '') : '');
		return this.get(name);
	}

	get(name) {
		name += '=';
		const b = document.cookie.split(';');
		let c = '';
		for (let i = 0; i < b.length; i++) {
			c = b[i].replace(/(^\s+)|(\s+$)/g, '');
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

	remove(name) {
		this.set(name, '', -1);
	}
}



// WEBPACK FOOTER //
// ./app/modules/cookie/cookie.js